import PayPaymentPlanError from './PayPaymentPlanError';
class PaymentPlanIsNotRegistered extends PayPaymentPlanError {
    paymentPlanId;
    constructor(paymentPlanId, options) {
        super('The requested payment plan was not found', options);
        this.paymentPlanId = paymentPlanId;
    }
}
export default PaymentPlanIsNotRegistered;
